// @flow
import React from 'react';
import { Route, Switch } from 'react-router';
import PrivateRoute from 'components/common/router/PrivateRoute';

// Components
import LandingPage from 'components/pages/SelfCheckIn/LandingPage';
import MileagePage from 'components/pages/SelfCheckIn/MileagePage';
import ReviewServicesPage from 'components/pages/SelfCheckIn/ReviewServicesPage';
import EditServicesPage from 'components/pages/SelfCheckIn/EditServicesPage';
import ConfirmationPage from 'components/pages/SelfCheckIn/ConfirmationPage';
import ErrorPage from 'components/pages/SelfCheckIn/ErrorPage';
import SpeakToAdvisorPage from 'components/pages/SelfCheckIn/SpeakToAdvisorPage';
import SignaturePage from 'components/pages/SelfCheckIn/SignaturePage';

// Constants
import {
  SCI_HOME_ROUTE,
  SCI_VEHICLE_ROUTE,
  SCI_SERVICES_ROUTE,
  SCI_EDIT_SERVICES_ROUTE,
  SCI_ADVISOR_ROUTE,
  SCI_CONFIRMATION_ROUTE,
  SCI_ERROR_ROUTE,
  SCI_SIGNATURE_ROUTE
} from 'constants/selfCheckIn';

const NoRoute = () => <div> Invalid route </div>;

// eslint-disable-next-line react/no-multi-comp
const Router = () => {
  return (
    <Switch key="routes">
      <PrivateRoute exact path={SCI_HOME_ROUTE} component={LandingPage} />
      <PrivateRoute path={SCI_VEHICLE_ROUTE} component={MileagePage} />
      <PrivateRoute path={SCI_SERVICES_ROUTE} component={ReviewServicesPage} />
      <PrivateRoute
        path={SCI_EDIT_SERVICES_ROUTE}
        component={EditServicesPage}
      />
      <PrivateRoute path={SCI_ADVISOR_ROUTE} component={SpeakToAdvisorPage} />
      <PrivateRoute path={SCI_ERROR_ROUTE} component={ErrorPage} />
      <PrivateRoute
        path={SCI_CONFIRMATION_ROUTE}
        component={ConfirmationPage}
      />
      <PrivateRoute path={SCI_SIGNATURE_ROUTE} component={SignaturePage} />
      <Route component={NoRoute} />
    </Switch>
  );
};

export default Router;



// WEBPACK FOOTER //
// ./src/components/selfCheckIn/AppRouter.js